module.exports = __webpack_public_path__ + "static/media/google-plus.b386d6de.svg";